/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PortfolioStatus } from './PortfolioStatus';
import {
    PortfolioStatusFromJSON,
    PortfolioStatusFromJSONTyped,
    PortfolioStatusToJSON,
    PortfolioStatusToJSONTyped,
} from './PortfolioStatus';
import type { PortfolioType } from './PortfolioType';
import {
    PortfolioTypeFromJSON,
    PortfolioTypeFromJSONTyped,
    PortfolioTypeToJSON,
    PortfolioTypeToJSONTyped,
} from './PortfolioType';
import type { PortfolioCashAccountCreateRequest } from './PortfolioCashAccountCreateRequest';
import {
    PortfolioCashAccountCreateRequestFromJSON,
    PortfolioCashAccountCreateRequestFromJSONTyped,
    PortfolioCashAccountCreateRequestToJSON,
    PortfolioCashAccountCreateRequestToJSONTyped,
} from './PortfolioCashAccountCreateRequest';
import type { PortfolioServicingRole } from './PortfolioServicingRole';
import {
    PortfolioServicingRoleFromJSON,
    PortfolioServicingRoleFromJSONTyped,
    PortfolioServicingRoleToJSON,
    PortfolioServicingRoleToJSONTyped,
} from './PortfolioServicingRole';

/**
 * 
 * @export
 * @interface PortfolioUpdateRequest
 */
export interface PortfolioUpdateRequest {
    /**
     * PCO portfolio number in dotted form {type}.{seq} (e.g. 02.02).
     * @type {string}
     * @memberof PortfolioUpdateRequest
     */
    portfolioNumber: string;
    /**
     * Unformatted sequence number of the portfolio within the business relationship (e.g. 1 for portfolio number 02.01).
     * @type {number}
     * @memberof PortfolioUpdateRequest
     */
    sequenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof PortfolioUpdateRequest
     */
    rubrik?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioUpdateRequest
     */
    details?: string;
    /**
     * 
     * @type {PortfolioType}
     * @memberof PortfolioUpdateRequest
     */
    portfolioType: PortfolioType;
    /**
     * 
     * @type {PortfolioStatus}
     * @memberof PortfolioUpdateRequest
     */
    portfolioStatus?: PortfolioStatus;
    /**
     * 
     * @type {string}
     * @memberof PortfolioUpdateRequest
     */
    referenceCurrency?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioUpdateRequest
     */
    chargingCurrency?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioUpdateRequest
     */
    allocatedBo?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioUpdateRequest
     */
    specialBoEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PortfolioUpdateRequest
     */
    businessRelationshipId?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioUpdateRequest
     */
    serviceAgreementId?: string;
    /**
     * 
     * @type {Date}
     * @memberof PortfolioUpdateRequest
     */
    closedAt?: Date;
    /**
     * 
     * @type {Array<PortfolioCashAccountCreateRequest>}
     * @memberof PortfolioUpdateRequest
     */
    cashAccounts?: Array<PortfolioCashAccountCreateRequest>;
    /**
     * 
     * @type {PortfolioServicingRole}
     * @memberof PortfolioUpdateRequest
     */
    servicingRole?: PortfolioServicingRole;
}



/**
 * Check if a given object implements the PortfolioUpdateRequest interface.
 */
export function instanceOfPortfolioUpdateRequest(value: object): value is PortfolioUpdateRequest {
    if (!('portfolioNumber' in value) || value['portfolioNumber'] === undefined) return false;
    if (!('portfolioType' in value) || value['portfolioType'] === undefined) return false;
    return true;
}

export function PortfolioUpdateRequestFromJSON(json: any): PortfolioUpdateRequest {
    return PortfolioUpdateRequestFromJSONTyped(json, false);
}

export function PortfolioUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'portfolioNumber': json['portfolioNumber'],
        'sequenceNumber': json['sequenceNumber'] == null ? undefined : json['sequenceNumber'],
        'rubrik': json['rubrik'] == null ? undefined : json['rubrik'],
        'details': json['details'] == null ? undefined : json['details'],
        'portfolioType': PortfolioTypeFromJSON(json['portfolioType']),
        'portfolioStatus': json['portfolioStatus'] == null ? undefined : PortfolioStatusFromJSON(json['portfolioStatus']),
        'referenceCurrency': json['referenceCurrency'] == null ? undefined : json['referenceCurrency'],
        'chargingCurrency': json['chargingCurrency'] == null ? undefined : json['chargingCurrency'],
        'allocatedBo': json['allocatedBo'] == null ? undefined : json['allocatedBo'],
        'specialBoEnabled': json['specialBoEnabled'] == null ? undefined : json['specialBoEnabled'],
        'businessRelationshipId': json['businessRelationshipId'] == null ? undefined : json['businessRelationshipId'],
        'serviceAgreementId': json['serviceAgreementId'] == null ? undefined : json['serviceAgreementId'],
        'closedAt': json['closedAt'] == null ? undefined : (new Date(json['closedAt'])),
        'cashAccounts': json['cashAccounts'] == null ? undefined : ((json['cashAccounts'] as Array<any>).map(PortfolioCashAccountCreateRequestFromJSON)),
        'servicingRole': json['servicingRole'] == null ? undefined : PortfolioServicingRoleFromJSON(json['servicingRole']),
    };
}

export function PortfolioUpdateRequestToJSON(json: any): PortfolioUpdateRequest {
    return PortfolioUpdateRequestToJSONTyped(json, false);
}

export function PortfolioUpdateRequestToJSONTyped(value?: PortfolioUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'portfolioNumber': value['portfolioNumber'],
        'sequenceNumber': value['sequenceNumber'],
        'rubrik': value['rubrik'],
        'details': value['details'],
        'portfolioType': PortfolioTypeToJSON(value['portfolioType']),
        'portfolioStatus': PortfolioStatusToJSON(value['portfolioStatus']),
        'referenceCurrency': value['referenceCurrency'],
        'chargingCurrency': value['chargingCurrency'],
        'allocatedBo': value['allocatedBo'],
        'specialBoEnabled': value['specialBoEnabled'],
        'businessRelationshipId': value['businessRelationshipId'],
        'serviceAgreementId': value['serviceAgreementId'],
        'closedAt': value['closedAt'] == null ? value['closedAt'] : value['closedAt'].toISOString().substring(0,10),
        'cashAccounts': value['cashAccounts'] == null ? undefined : ((value['cashAccounts'] as Array<any>).map(PortfolioCashAccountCreateRequestToJSON)),
        'servicingRole': PortfolioServicingRoleToJSON(value['servicingRole']),
    };
}

